document.addEventListener('click', (event) => {
  const proofLink = event.target.closest('[data-nv-proof-id]');
  if (!proofLink) return;
  const info = proofLink.closest('product-info');
  const gallery = info?.querySelector('media-gallery');
  const target = gallery?.querySelector('[data-target$="-' + proofLink.dataset.nvProofId + '"]');
  const button = target?.querySelector('button');
  if (button) {
    event.preventDefault();
    button.click();
    gallery.scrollIntoView({block:'start',behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
    button.focus({preventScroll:true});
  }
});
